import './system.css';
import Kicker from '../Kicker';

/**
 * Shared empty state for surfaces that loaded successfully but have nothing
 * to show (quiet leaderboards, aircraft with no recent history, etc).
 * @param {{ kicker?: string, title: string, detail?: string, cta?: React.ReactNode }} props
 */
function EmptyState({ kicker, title, detail, cta }) {
  return (
    <div className="sys-empty">
      {kicker && <Kicker>{kicker}</Kicker>}
      <h2 className="sys-empty-title">{title}</h2>
      {detail && <p className="sys-empty-detail">{detail}</p>}
      {cta && <div className="sys-empty-cta">{cta}</div>}
    </div>
  );
}

export default EmptyState;
